// @ts-nocheck
// Call Stats — shared chart/section card. Built entirely on Tailwind +
// shadcn tokens (not the old `.agent-call-stats-chart-card` cti.css
// classes) so this page's chrome isn't dependent on a file that's off
// limits to edit (cti.css is one of the protected production stylesheets).
import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import { HAIRLINE, HAIRLINE_SOFT } from '@/features/cti/ctiHelpers';

export default function ChartCard({ title, eyebrow, subtitle, children, onRefresh, actions, className = '' }: any) {
  return (
    <div className={`cti-kpi-card card-hover-raise flex h-full flex-col rounded-2xl border ${HAIRLINE} bg-card shadow-sm ${className}`.trim()}>
      <div className={`flex items-center justify-between gap-4 border-b ${HAIRLINE_SOFT} px-4 py-3`}>
        <div className="min-w-0">
          {eyebrow ? (
            <div className="mb-0.5 text-[10px] font-semibold uppercase tracking-[0.11em] text-muted-foreground">
              {eyebrow}
            </div>
          ) : null}
          <h3 className="truncate text-[13px] font-semibold text-foreground">{title}</h3>
          {subtitle ? <p className="mt-0.5 truncate text-[11px] text-muted-foreground">{subtitle}</p> : null}
        </div>
        <div className="flex shrink-0 items-center gap-1.5">
          {actions}
          {onRefresh ? (
            <button
              type="button"
              onClick={onRefresh}
              title="Refresh"
              className={`flex h-7 w-7 items-center justify-center rounded-full border ${HAIRLINE} text-muted-foreground transition-colors hover:border-foreground/30 hover:text-foreground`}
            >
              <FiRefreshCw size={13} />
            </button>
          ) : null}
        </div>
      </div>
      <div className="flex-1 p-3">{children}</div>
    </div>
  );
}
